import subscriptionClient from '@/graphql/subscriptionClient'

export const addToSubscriptions = (query, variables, callback) => {
  return subscriptionClient.subscribe({
    query,
    variables,
    onNext: (data) => callback(data),
    onError: (error) => console.error('Subscription error:', error)
  })
}
